import type { ReactNode } from 'react';

import { useSearchParams } from '@remix-run/react';
import type { TSignupModalElement } from '@shared/dream-components';
import { SignupModalElement } from '@shared/dream-components';
import { ClientOnly } from 'remix-utils/client-only';

import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

interface Props {
  node: TSignupModalElement;
  children: ReactNode | ReactNode[];
}

const SignupModal = ({ node, children }: Props) => {
  const { currentModal } = useGlobalModals();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <ClientOnly fallback={null}>
      {() => (
        <SignupModalElement
          element={node}
          isOpen={currentModal === 'signup'}
          onOpenChange={(isOpen: boolean) => {
            if (!isOpen) {
              searchParams.delete('premium_offer_id');
              searchParams.delete('tier_id');
              searchParams.delete('signup_flow_id');
              searchParams.delete('modal');
              setSearchParams(searchParams, { preventScrollReset: true });
            }
          }}
        >
          {children}
        </SignupModalElement>
      )}
    </ClientOnly>
  );
};

export default SignupModal;
